export default "__VITE_ASSET__CIUKHgZP__"